
define('text!pages/home/home_page_intro_template.html',[],function () { return '<img src="images/intro.jpg" alt="">\r\n<div class="home-intro__text js-intro"></div>\r\n';});

